import React, { useState, useEffect } from 'react';

const SearchField = (props) => {
    const [searchText, setSearchText] = useState(null);
    const { label, list, setSearchedRows } = props;
    useEffect(() => {
        if (searchText && searchText !== '') {
            var result = [];
            if (list && list.length > 0) {
                result = list.filter((item) =>
                    Object.keys(item).some(
                        (k) =>
                            item[k] !== null &&
                            item[k].toString().toLowerCase().includes(searchText.toLowerCase()),
                    ),
                );
            }
            setSearchedRows(result);
        } else {
            setSearchedRows(list);
        }
    }, [searchText, list, setSearchedRows]);

    return (
        <div className='flex column justifyStart alignStart search_box w-100'>
            <h2> {label} </h2>
            <input
                type='text'
                autoFocus='on'
                placeholder='3520212345678'
                onChange={(e) => setSearchText(e.target.value)}
            />
        </div>
    );
};

export default SearchField;
